// Identifies this running instance of the web app — one browser tab, from
// boot until refresh. Deliberately in memory rather than any storage: the
// waiters and subscriptions that delivery targeting serves die with the
// page, so their target id must too (and tab duplication copies
// sessionStorage, which would put two tabs behind one id).
//
// Sent in a header on every API request and declared in the socket
// handshake; the server delivers instance-addressed messages only to this
// tab. Absence has meaning — the server falls back to session-wide
// delivery — so nothing may treat this id as required.
export const APP_INSTANCE_ID = crypto.randomUUID()
